import React, { useEffect, useState } from "react";
import "../App.css";
import "./css/Main.css";
import { RetellWebClient } from "retell-client-js-sdk";

const agentId = "agent_2de019e52b9b6f95c18cbdc8bd";

interface RegisterCallResponse {
  access_token: string;
}

const retellWebClient = new RetellWebClient();

const Home = () => {
  const [isCalling, setIsCalling] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Load GHL widget dynamically
    const script = document.createElement("script");
    script.src = "https://widgets.leadconnectorhq.com/loader.js";
    script.setAttribute("data-resources-url", "https://widgets.leadconnectorhq.com/chat-widget/loader.js");
    script.setAttribute("data-widget-id", "68093cf6b75db5201353db80");
    script.async = true;
    document.body.appendChild(script);

    // Event listeners for Retell
    retellWebClient.on("call_started", () => {
      console.log("call started");
    });

    retellWebClient.on("call_ended", () => {
      console.log("call ended");
      setIsCalling(false);
      setIsLoading(false);
    });

    retellWebClient.on("agent_start_talking", () => {
      console.log("agent_start_talking");
    });

    retellWebClient.on("agent_stop_talking", () => {
      console.log("agent_stop_talking");
    });

    retellWebClient.on("error", (error) => {
      console.error("An error occurred:", error);
      retellWebClient.stopCall();
      setIsCalling(false);
      setIsLoading(false);
    });
  }, []);

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const toggleConversationDebounced = debounce(async () => {
    if (isLoading) return;
    setIsLoading(true);

    if (isCalling) {
      retellWebClient.stopCall();
      setIsCalling(false);
    } else {
      try {
        const registerCallResponse = await registerCall(agentId);
        if (registerCallResponse.access_token) {
          await retellWebClient.startCall({
            accessToken: registerCallResponse.access_token,
          });
          setIsCalling(true);
        }
      } catch (error) {
        console.error("Error starting call:", error);
      } finally {
        setIsLoading(false);
      }
    }
  }, 300);

  async function registerCall(agentId: string): Promise<RegisterCallResponse> {
    try {
      const response = await fetch("https://demo.braincx.ai:8080/create-web-call", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ agent_id: agentId }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      return await response.json();
    } catch (err) {
      console.error("Error registering call:", err);
      throw err;
    }
  }

  return (
    <div className="App">
      <header className="center">
        <div className="logo-div">
          <img className="logo-main" src="/images/logo-white.png" alt="BrainCX Logo" />
        </div>
        <div className="button-div"></div>
        <div className="icon-div">
          <div className="menu-icon">
            <i className="fa-solid fa-bars fa-lg"></i>
          </div>
        </div>
      </header>

      <div className="content center">
        <h1 className="main-heading">Demo for Thumbtack</h1>
        <img src="/images/thumbtack1.png" alt="BrainCX Logo" width="120" height="120" />
        <p className="sub-heading">Caring For Your Home, Made Easy</p>
        <p className="sub-heading">BrainCX made it even easier — AI-powered help for every home repair.</p>

        <div className="buttons">
          <a
            className="btn-01"
            href="#"
            onClick={toggleConversationDebounced}
            style={{ pointerEvents: isLoading ? "none" : "auto", opacity: isLoading ? 0.7 : 1 }}
          >
            {isCalling ? "Stop Demo" : "Click here to play live demo"}
          </a>
        </div>
      </div>

      <div className="wave-section">
        <div className="main-button">
          <video className="video-back" autoPlay loop muted playsInline>
            <source src="/images/wave-ai.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <img
            className="main-audio-button"
            src="/images/button.png"
            alt="Audio Button"
            onClick={toggleConversationDebounced}
            style={{ pointerEvents: isLoading ? "none" : "auto", opacity: isLoading ? 0.7 : 1 }}
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
